import Vue from "vue";
import { getProductDBContentForProductID } from "../../services/MainService";

const initialState = {
    basket: {}
}

const state = {
    ...initialState
}

const getters = {
    getBasketCount(state) {
        return Object.keys(state.basket).length;
    }
}

const mutations = {
    // adds 1 item to the basket
    addToBasket(state, payload) {
        // create new baket item if product not in basket
        if ((payload["productId"] in state.basket) === false) {
            Vue.set(state.basket, payload["productId"], {
                "qty": 1,
                "title": payload["productTitle"],
                "img": payload["productImage"],
                "costInformation": payload["costInformation"]
            });
            console.log(state.basket)
        }
        // increase quantity if product already in basket
        else {
            console.log("Item is already in basket. Basket remains unchanged.")
        }

        // record interaction for data tracking
        const interactionData = {
            eventType: "basketChanged",
            eventData: {
                newBasket: state.basket
            }
        };

        // send request to record interaction 2 seconds later
        // this is to avoid that data tracking events are not logged properly when generated session document is not ready at beginning
        setTimeout(() => {
            this.dispatch('recordInteraction', interactionData, { root: true })
        }, 2000);
        
    },

    // removes 1 item from the basket
    removeFromBasket(state, payload) {
        if (payload.force === true) {
            Vue.delete(state.basket, payload["productId"])
        }
        // this else clause is not used so far, as there are not qtys in the app
        else {
            // reduce quantity by 1 if basket item is present
            if (payload["productId"] in state.basket) {
                Vue.set(state.basket[payload["productId"]], "qty", state.basket[payload["productId"]] - 1)
            }

            // remove complete item if quantity is 0
            if (state.basket[payload["productId"]].qty === 0) {
                Vue.delete(state.basket, payload["productId"])
            }
        }

        // record interaction for data tracking
        const interactionData = {
            eventType: "basketChanged",
            eventData: {
                newBasket: state.basket
            }
        };
        this.dispatch('recordInteraction', interactionData, { root: true })
    },

    // removes all items from the basket
    clearBasket(state){
        console.log("clearing basket")
        Object.assign(state, initialState)    
    }

}

const actions = {
    // adds an array of product IDs to the basket
    // note: image, costInformation is NOT required, and is fetched from server
    async addProductIDsToBasket(context, payload){
        const prdData = await getProductDBContentForProductID(payload);
        if (prdData.success === true){
            for (let product of prdData.data.products){
                const prdBaketObj = {
                    productId: product.productID,
                    productTitle: product.title.product,
                    productImage: product.content.images[0].src,
                    costInformation: product.costInformation
                }
                context.commit('addToBasket', prdBaketObj)
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


